import * as R from 'ramda';
import ReactSVG from 'react-svg';
import React, { useState } from 'react';
import { inject, observer } from 'mobx-react';
import intl from 'react-intl-universal';

import MultiSelect, {
  generateOptionsByCommaString,
} from 'components/MultiSelect/MultiSelect';
import Button from 'components/Common/Button';
import useTheme from 'components/hooks/useTheme';
import { IComponentMobileUpload } from 'component';

import './AllForMobileUpload.scss';
import { style } from 'utils/image';

let mobileUploading = false;

const AllForMobileUpload = function (props: IComponentMobileUpload) {
  const { title, value, enableUploadToTag, remarkImage, max = 20 } = props;
  const { commonStore, uiStore, galleryStore, wxuserStore } = props.rootStore!;
  const theme = useTheme();
  const [formData, setFormData] = useState({} as any);
  const [fileList, setFileList] = useState([
    // 'source/146d32234aef252ebfec352d769b5d318.jpg',
    // 'source/1008e8156130be276723fa80165dc8d73.jpg',
  ] as any);

  const [selectedTags, setSelectedTags] = useState([] as any);

  const tags = R.pathOr('', ['gallery', 'tags'], window);

  const onSubmit = () => {

    const wechatShareIsTurnOn = R.pathEq(1,['configDetail', 'active_on'])(window);

    if(wechatShareIsTurnOn){
      //  微信分享开启状态
      //  验证登录
      if (wxuserStore.user.is_mock) {
        wxuserStore.auth();
        return;
      }
    }

    //  是否需要输入备注
    let { code } = formData;
    if (remarkImage && !code) {
      uiStore.showToast({
        content: '请输入照片对应的' + title,
      });
      return;
    }

    //  是否选择了照片
    if (fileList.length === 0) {
      uiStore.showToast({
        content: '请先选择并上传照片',
      });
      return;
    }

    //  相册id获取失败
    if (!value) {
      //  value 为相册id
      uiStore.showToast({
        content: '上传相册异常，请联系管理员',
      });
      return;
    }

    {
      const batchUpdate = (keys: any) => {
        if (mobileUploading) {
          return;
        }

        uiStore.showToast({
          content: '正在提交中',
          time: 0,
        });

        const promises = keys.map((key: any, index: number) => {
          //  用index设置延迟, 这样避免对后台服务器瞬时压力过大, 用index*200毫秒的延迟
          return new Promise((resolve) => {
            setTimeout(() => {
              galleryStore
                .uploadImage(
                  Number(value),
                  key,
                  remarkImage ? code : '',
                  selectedTags.join(',')
                )
                .then(resolve);
            }, index * 200);
          });
        });

        Promise.all(promises).then(() => {
          uiStore.hideToast();
          setFileList([]);
          mobileUploading = false;
          uiStore.showToast({
            content: '提交完成',
          });
        });
      };

      batchUpdate(fileList);
    }
  };

  return (
    <div className="all-for-mobileupload">
      {remarkImage && (
        <div className="c-form">
          <div className="c-form-label" style={{ color: theme.h1Color }}>
            {title}
          </div>
          <div className="c-form-content">
            <input
              name="code"
              placeholder={intl.get(`uploadTooltip`, {
                title
              })}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  code: e.target.value,
                });
              }}
              style={{ color: theme.h1Color, padding: `0 1em` }}
            />
          </div>
        </div>
      )}
      {enableUploadToTag && tags && (
        <div className="c-form">
          <div
            key="标签这个文字得改一下，这个是内部叫法，对外我想改为：上传至, 此外, 有标签的相册较少, 所以有标签的情况下才展示"
            className="c-form-label"
            style={{ color: theme.h1Color }}
          >
            上传至
          </div>
          <div className="c-form-content">
            <MultiSelect
              options={generateOptionsByCommaString(tags)}
              onChange={setSelectedTags}
            />
          </div>
        </div>
      )}
      <div className="c-form">
        <div className="c-form-content c-form-upload-list">
          {fileList.map((key: any, index: number) => {
            return (
              <div className="c-form-upload" key={`${index}_${key}`}>
                <div
                  className="upload-preview"
                  style={{
                    backgroundImage: `url(${style(key, 'avatar_150')})`,
                  }}
                ></div>
                <ReactSVG
                  className="upload-close"
                  src={require('../../svg/video-close.svg')}
                  style={{ width: 18, height: 18, padding: `2px` }}
                  onClick={() => {
                    let newFileList = [...fileList];
                    newFileList.splice(index, 1);
                    setFileList(newFileList);
                  }}
                />
              </div>
            );
          })}
          {fileList.length < Number(max) ? (
            <div className="c-form-upload c-form-upload-add">
              <input
                type="file"
                name="image"
                accept="image/*"
                multiple
                onChange={(e: any) => {
                  const length = R.pathOr(0, ['target', 'files', 'length'], e);
                  if (length + fileList.length > Number(max)) {
                    uiStore.showToast({
                      content: `单次最多上传${max}张照片, 请重新选择`,
                    });
                    return;
                  }

                  function uploadMultipleImages(files: any) {
                    //  避免文件名重复, 采取当前毫秒数除去最后三位数字
                    const currentDateTimeWithoutLastThreeDigital = Date.now()
                      .toString()
                      .slice(0, -3);
                    const keys = files.map((_: any, index: number) => {
                      //  通过当前的index, 生成三位数的字符串, 例如 1 -> 001, 这样可以保证0~999的文件名都不会重复, 毕竟后台不可能设置上传1000张照片
                      const indexWithPadThreeZeroBefore = index
                        .toString()
                        .padStart(3, '0');
                      return `poster/${window.gallery.id}_${currentDateTimeWithoutLastThreeDigital}${indexWithPadThreeZeroBefore}.jpg`;
                    });
                    const promises = keys.map(
                      (key: any, index: number) =>
                        new Promise((resolve) => {
                          commonStore
                            .uploadImage(
                              {
                                key: key,
                                file: files[index],
                              },
                              'file',
                              true
                            )
                            .then(resolve);
                        })
                    );
                    //  此处不做限流, 因为使用的是阿里云oss, 上传速度很快, 且不会对服务器造成压力
                    Promise.allSettled(promises).then(() => {
                      uiStore.showToast({
                        time: 1000,
                        content: '预览成功',
                      });
                      setFileList([...fileList, ...keys]);
                    });
                  }
                  const files = Array.from(
                    R.pathOr([], ['target', 'files'], e)
                  );

                  //  上传图片
                  {
                    uiStore.showToast({
                      content: '正在上传中',
                      time: 10 * 1000,
                    });
                    uploadMultipleImages(files);
                  }
                }}
              />
            </div>
          ) : null}
        </div>
      </div>
      <div className="c-form">
        <div className="c-hrule"></div>
      </div>
      <div className="c-form">
        <div className="c-form-content">
          <Button onClick={onSubmit}>{intl.get('Submit')}</Button>
        </div>
      </div>
    </div>
  );
};

export default inject('rootStore')(observer(AllForMobileUpload));
